import { render, staticRenderFns } from "./spot_space_inquiry_detail.vue?vue&type=template&id=79c547b5&scoped=true&"
import script from "./spot_space_inquiry_detail.vue?vue&type=script&lang=js&"
export * from "./spot_space_inquiry_detail.vue?vue&type=script&lang=js&"
import style0 from "./spot_space_inquiry_detail.vue?vue&type=style&index=0&id=79c547b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c547b5",
  null
  
)

export default component.exports